import { SAVED_ITEMS_SDK_FAILURE } from "../../../../state/modules/savedItems/constants";
import { SIMILAR_ITEMS_INITIALISATION_FAILURE } from "../../../../state/modules/similarItems/constants";
import content from "app-content";

const mapActionTypeToErrorMessage = mostRecentError => {
  switch (mostRecentError.type) {
    case SAVED_ITEMS_SDK_FAILURE:
    case SIMILAR_ITEMS_INITIALISATION_FAILURE:
      return content.saved_items_api_failure_transient_message;
  }
};

export default ({ common: { persistentErrors } }) => {
  const mostRecentError = persistentErrors[persistentErrors.length - 1];
  if (mostRecentError) {
    return mapActionTypeToErrorMessage(mostRecentError);
  }
};
